export default {
  loading: 'before',
  tasks: []
}
